import type { InventoryLevel } from '@techpos/contracts';
export function stockAlerts(item: Pick<InventoryLevel, 'quantity' | 'minimumLevel' | 'maximumLevel'>) {
  return { low: item.minimumLevel !== null && item.quantity <= item.minimumLevel,
    over: item.maximumLevel !== null && item.quantity > item.maximumLevel };
}
